export default "/_next/static/images/ff4cd27690e20867f89673276de1ca97.jpg";